/**
* 左边菜单
*/
<template>
  <el-menu default-active="10" :collapse="collapsed" collapse-transition router :default-active="$route.path" class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
      <div style="line-height: 70px;font-size: 24px;color: #FFFFFF;margin-left: 10px;">后台管理系统</div>
    </div>
    <el-submenu v-for="menu in allmenu" :key="menu.menuid" :index="menu.menuname">
      <template slot="title">
        <i class="iconfont" :class="menu.icon"></i>
        <span>{{menu.menuname}}</span>
      </template>
      <el-menu-item-group>
        <el-menu-item v-for="chmenu in menu.menus" :index="'/'+chmenu.url" :key="chmenu.menuid">
          <i class="iconfont" :class="chmenu.icon"></i>
          <span>{{chmenu.menuname}}</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-submenu>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
export default {
  name: 'leftnav',
  data() {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    // TODO 2023.10.29 奇点折叠后台管理系统
    // TODO 其实应该后台获取菜单列表，需要鉴权后返回
    // TODO 暂时就我一个人用，先不管它
    let res = {
      success: true,
      data: [
        {
          menuid: 0,
          icon: 'icon-cus-manage',
          menuname: '数据中心',
          hasThird: 'Y',
          url: null,
          menus: [
            {
              menuid: 10,
              icon: 'icon-order-manage',
              menuname: '数据中心',
              hasThird: 'N',
              url: 'data/data',
              menus: null
            }
          ]
        },
        {
          menuid: 1,
          icon: 'icon-cus-manage',
          menuname: '用户管理',
          hasThird: 'N',
          url: null,
          menus: [
            {
              menuid: 11,
              icon: 'icon-order-manage',
              menuname: '用户列表',
              hasThird: 'N',
              url: 'user/user',
              menus: null
            },
            {
              menuid: 12,
              icon: 'icon-order-manage',
              menuname: '风险内容审核',
              hasThird: 'N',
              url: 'user/sensitiveCheck',
              menus: null
            }
          ]
        },
        {
          menuid: 2,
          icon: 'li-icon-xiangmuguanli',
          menuname: '纸条管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 21,
              icon: 'icon-order-manage',
              menuname: '纸条列表',
              hasThird: 'N',
              url: 'user/paper',
              menus: null
            }
          ]
        },
        {
          menuid: 3,
          icon: 'li-icon-xiangmuguanli',
          menuname: '基础管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 31,
              icon: 'icon-order-manage',
              menuname: '基础配置',
              hasThird: 'N',
              url: 'system/Variable',
              menus: null
            },
            {
              menuid: 32,
              icon: 'icon-order-manage',
              menuname: '会员配置',
              hasThird: 'N',
              url: 'system/vipConfig',
              menus: null
            }
          ]
        },
        {
          menuid: 4,
          icon: 'li-icon-dingdanguanli',
          menuname: '订单管理',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 41,
              icon: 'icon-order-manage',
              menuname: '交易订单',
              hasThird: 'N',
              url: 'pay/Order',
              menus: null
            }
          ]
        },
        {
          menuid: 5,
          icon: 'li-icon-shangchengxitongtubiaozitihuayuanwenjian91',
          menuname: '数据可视化',
          hasThird: null,
          url: null,
          menus: [
            {
              menuid: 51,
              icon: 'icon-provider-manage',
              menuname: '数据中心',
              hasThird: 'N',
              url: 'charts/statistics',
              menus: null
            }
          ]
        }
      ],
      msg: 'success'
    }
          this.allmenu = res.data

    // menu(localStorage.getItem('logintoken'))
    //   .then(res => {
    //     console.log(JSON.stringify(res))
    //     if (res.success) {
    //       this.allmenu = res.data
    //     } else {
    //       this.$message.error(res.msg)
    //       return false
    //     }
    //   })
    //   .catch(err => {
    //     this.$message.error('菜单加载失败，请稍后再试！')
    //   })
    // 监听
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value
      this.$store.commit('changeShowBanquan')
    })
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}
.el-menu-item-group__title {
  padding: 0px;
}
.el-menu-bg {
  background-color: #1f2d3d !important;
}
.el-menu {
  border: none;
}
.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
  display: flex;
}
.logoimg {
  height: 60px;
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue